import { render, staticRenderFns } from "./PushNotificationActivator.vue?vue&type=template&id=e44615bc"
import script from "./PushNotificationActivator.vue?vue&type=script&lang=js"
export * from "./PushNotificationActivator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports